import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IQuery } from 'core-ts-types';
import { SchedulerModel } from '../../course_scheduler/models/scheduler_model';

interface IPayTuitionQueryResult {
  showPayTuition: boolean;
  payTuitionURL: string;
}

export class PayTuitionQuery implements IQuery {
  private _result: IPayTuitionQueryResult;

  constructor(private ngSchedulerModel: SchedulerModel) {
    Query.registerQuery(this, ngSchedulerModel);
  }

  run() {
    const payTuitionURL = _4.get<string>(this.ngSchedulerModel.read(), 'customtext.PAY_TUITION_URL.text');
    this._result = {
      showPayTuition: !_4.isEmpty(payTuitionURL),
      payTuitionURL: payTuitionURL
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngPayTuitionQuery', PayTuitionQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/queries/pay_tuition_query.ts